module.exports = __webpack_public_path__ + "img/vayonet-gorseli-700x450.3407aa6d.png";